import React from 'react';
import {faExternalLinkAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default function ExternalLink({to, children}){
    return <a href={to} target={"_blank"}>{children} <FontAwesomeIcon icon={faExternalLinkAlt}/></a>
}